import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGeneralContext } from "../../Contexts/GeneralContext/GeneralProvider";
import { GetHomePath, HasPreviousAppEntry } from "../../Helpers/RouteHelpers";

// Makes Entrada the first entry of the app in the browser history, so pressing back keeps
// ending on Entrada instead of leaving the app, also when the page was opened on another
// screen from a link or a reload.
function useHomeAsHistoryOrigin() {

	const { appLocation } = useGeneralContext()
	const location = useLocation()
	const navigate = useNavigate()
	const homePath = appLocation ? GetHomePath(appLocation.area, appLocation.schoolSK) : undefined
	const isOnUnknownPath = !!appLocation && !appLocation.section

	useEffect(() => {
		if (homePath && isOnUnknownPath) {
			navigate(homePath, { replace: true })
		}
	}, [homePath, isOnUnknownPath, navigate])

	useEffect(() => {
		if (!homePath || isOnUnknownPath || HasPreviousAppEntry()) {
			return
		}
		// Chrome's back button skips history entries added without a user gesture, so the
		// history can only be reshaped from inside one.
		const putHomeUnderCurrentEntry = () => {
			if (location.pathname === homePath) {
				navigate(homePath)
				return
			}
			navigate(homePath, { replace: true })
			navigate({ pathname: location.pathname, search: location.search }, { state: location.state })
		}
		window.addEventListener('click', putHomeUnderCurrentEntry, { capture: true, once: true })
		window.addEventListener('keydown', putHomeUnderCurrentEntry, { capture: true, once: true })
		return () => {
			window.removeEventListener('click', putHomeUnderCurrentEntry, { capture: true })
			window.removeEventListener('keydown', putHomeUnderCurrentEntry, { capture: true })
		}
	}, [homePath, isOnUnknownPath, location.key, location.pathname, location.search, location.state, navigate])
}

export default useHomeAsHistoryOrigin
